import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {adminRequest, buildQuery, getReturnedObject} from "../../api/adminApi";

const initialState = {
  cards: null as any,
  loading: false,
  error: undefined as string | undefined,
};

type DashboardCardsRequest = {
  token: string;
  startDate?: string;
  endDate?: string;
};

export const getDashboardCards = createAsyncThunk<any, DashboardCardsRequest>(
  "dashboard/getCards",
  async ({token, startDate, endDate}) => {
    const query = buildQuery({startDate, endDate});
    return adminRequest(`/dashboard/cards${query}`, {token});
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardCards.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(getDashboardCards.fulfilled, (state, action) => {
        state.loading = false;
        state.cards = getReturnedObject(action.payload);
      })
      .addCase(getDashboardCards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default dashboardSlice.reducer;
